import { Create, SimpleForm, TextInput } from 'react-admin';
import { createUpdateStyle } from '../../style';
import Typography from '@material-ui/core/Typography';
import { CustomToolbar } from '../../components/CustomToolBar';

export const BrandCreate = (props) => {
  const classes = createUpdateStyle();
  return (
    <div className={classes.card}>
      <a className={classes.breadcrumbLink} href="#/brand">
        {'< Brands'}
      </a>
      <Create title="Add Brand" {...props}>
        <SimpleForm redirect="list" toolbar={<CustomToolbar {...props} />}>
          <Typography variant="h6">Add Brand</Typography>
          <TextInput source="name" className={classes.textField} helperText={false} />
          <TextInput source="code" className={classes.textField} helperText={false} />
        </SimpleForm>
      </Create>
    </div>
  );
};
